import { Cloud, Lock, Timer, ShieldCheck } from "lucide-react";

const TRUST_ITEMS = [
  {
    icon: Cloud,
    label: "AWS S3 Cloud Infrastructure",
  },
  {
    icon: Lock,
    label: "Military-Grade Encryption",
  },
  {
    icon: Timer,
    label: "Auto-Deletion after 1 Hour",
  },
  {
    icon: ShieldCheck,
    label: "GDPR Compliant",
  },
];

/**
 * Security-focused trust bar shown in place of generic "Industry Leader"
 * testimonials. As an early-stage product without a large customer base to
 * quote, concrete, verifiable security facts build more credibility than
 * fabricated-sounding social proof.
 */
export default function SecurityTrustBar() {
  return (
    <section className="py-10 sm:py-12 bg-gray-50 border-y border-gray-200">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {TRUST_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.label}
                className="flex flex-col items-center text-center gap-2 px-2"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-gray-700">
                  {item.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
